import * as React from "react";
const SvgVideoTutorial = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="M19.866 0H8.134C3.038 0 0 3.038 0 8.134v11.718C0 24.962 3.038 28 8.134 28h11.718c5.096 0 8.134-3.038 8.134-8.134V8.134C28 3.038 24.962 0 19.866 0m-2.142 16.422-1.792 1.036-1.792 1.036c-2.31 1.33-4.2.238-4.2-2.422v-4.144c0-2.674 1.89-3.752 4.2-2.422l1.792 1.036 1.792 1.036c2.31 1.33 2.31 3.514 0 4.844"
    />
  </svg>
);
export default SvgVideoTutorial;
